import PropTypes from "prop-types";

import i18n from "../../../i18n";

import SplitButton from "../SplitButton";

import useEquipmentService from "../../../services/equipmentService";

import { useAsyncFn } from "../../../hooks/useAsync";

import { useSnackbarAlert } from "../../../context/snackbarAlert";

function ChangeEquipmentUsageVerificationButton(props) {
  const snackbarAlert = useSnackbarAlert();

  const { changeEquipmentUsageVerification } = useEquipmentService();
  const changeEquipmentUsageVerificationFn = useAsyncFn(
    changeEquipmentUsageVerification
  );

  const handlechangeEquipmentUsageVerificationButton = (verificationValue) => {
    if (props.selectedEquipmentUsageIds.length === 0) return;

    changeEquipmentUsageVerificationFn
      .execute(props.selectedEquipmentUsageIds, verificationValue)
      .then(() => {
        if (props.onSubmit) props.onSubmit();
        snackbarAlert.openSuccessSnackbarAlert(
          i18n.t("snackbar_alert.saved_changes")
        );
      })
      .catch(() => {
        snackbarAlert.openErrorSnackbarAlert(
          i18n.t("snackbar_alert.occurred_error_during_saving_changes")
        );
      });
  };

  const massActions = [
    {
      label: i18n.t(`true`),
      callback: () => handlechangeEquipmentUsageVerificationButton(true),
    },
    {
      label: i18n.t(`false`),
      callback: () => handlechangeEquipmentUsageVerificationButton(false),
    },
  ];

  return (
    <>
      <SplitButton
        label={i18n.t("bar.tool_bar.equipment_usage_verified")}
        withChangeSelectedItem={false}
        color={props.color}
        options={massActions}
      />
    </>
  );
}

ChangeEquipmentUsageVerificationButton.propTypes = {
  color: PropTypes.string,
  selectedEquipmentUsageIds: PropTypes.array,
  onSubmit: PropTypes.func,
};

ChangeEquipmentUsageVerificationButton.defaultProps = {
  color: "success",
  selectedEquipmentUsageIds: [],
};

export default ChangeEquipmentUsageVerificationButton;
